<template>
  <div class="bg_gray">
    <iframe v-bind:src="liveLocation" frameborder="0"  height="100%" class="frame"></iframe>
    <div ref="container"></div>
  </div>
</template>
<script>
    import '@/assets/classmatter.css'
    export default {
      name: "whiteBoard",
      data () {
          return {
            userInfo: {},
            liveDetail: {},
            liveLocation:'',
          }
        },
        mounted() {
          this.getParams();
        },
        methods:{
          getParams:function () {
            // 接收传过来的课程信息
            this.userInfo = this.$route.query.userInfo;
            this.liveDetail = this.$route.query.liveDetail;  
            console.log(this.userInfo)
            console.log(this.liveDetail)
            // 线下测试
            // this.liveLocation = 'https://localhost:8080/#/login'
            console.log(this.liveLocation)
            // 线上运行
            this.liveLocation = 'https://www.rujiaowang.net/public/liveClass/#/main'
              + '?accid=' + this.userInfo.accid
              + '&acctoken=' + this.userInfo.acctoken
            + '&nickName=' + this.userInfo.user_nicename
            + '&cid=' + this.liveDetail.speaker_teacher_id
            + '&room_id=' + this.liveDetail.room_id
            console.log(this.liveLocation)
          }
      },

    }
</script>



// WEBPACK FOOTER //
// src/pages/whiteBoard/whiteBoard.vue